import React, { useContext } from "react";
import WalletViewModel from "../viewModel";
import Button from "../../../components/Button";
import Card from "../../../components/Card";

const ChangeWallet = () => {
  const { requestAccounts, address, onConfirm, isChainValid } = useContext(
    WalletViewModel.Context
  );
  return (
    <Card>
      <h2>Change Wallet Address</h2>
      <Button variant={"secondary"} onClick={() => requestAccounts()}>
        Connect Wallet
      </Button>
      <span className={"text"}>Your selected address is:</span>
      <h5 className={"address"}>{address || "N/A"}</h5>
      <Button
        onClick={() => onConfirm(address)}
        disabled={!address || !isChainValid}
        className={"default-btn confirm-btn"}
      >
        Confirm
      </Button>
    </Card>
  );
};

export default ChangeWallet;
